import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=4038a142&scoped=true&"
var script = {}
import style0 from "./Pc.vue?vue&type=style&index=0&id=4038a142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038a142",
  null
  
)

export default component.exports